import { useState } from 'react'
import { classNames, Spinner, apiClient } from '../utils/helpers';
import Countdown from 'react-countdown';

import {
  CheckIcon,
} from '@heroicons/react/20/solid';
import { useTranslation } from 'react-i18next';

export default function VerifyPhone(props) {

  const { t } = useTranslation();
  const [form, setForm] = useState(
    {
      country:'86',
      phone:''
    });
  const [error,setError] = useState('');
  const [smsSent,setSmsSent] = useState(false);
  const [smsLock, setSmsLock] = useState(false);
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  const smsCountdown = 60000

  const countdown = ({ hours, minutes, seconds, completed }) => {
    if (completed) {      
      setSmsLock(false)
    } else {      
      return <span>{seconds}</span>;
    }
  };

  function checkPhone()
  {
    if(!form.phone) {
      setError('phone_required');
    } else {
      if(props.checkUser) {
        
        apiClient.post(`/api/check_phone`,{
          country: form.country,
          phone: form.phone
        })
        .catch(function(err){
          setError(err.response.data.message)
        })
        .then((response) => {
          if(response.data.customer && response.data.customer === true) {
            sendSMS();
          } else {
            setError('phone_check_error')
          }
        })    

      } else {
        sendSMS();
      }
    }    
  }

  function sendSMS() {    

    setSmsLock(true)
    setError(false)

    apiClient.post(`/api/send_sms`,{
      country: form.country,
      phone: form.phone
    })
    .catch(function(err){
      setError(err.response.data.message)
    })
    .then((response) => {
      if(response) {        
        setSmsSent(response.data.to)        
      }
    })    

  }

  async function verifySMS() {
    setLoading(true)
    
    apiClient.post(`/api/verify_otp`,{
      code: form.code,
      to: smsSent,
      type: 'sms'
    })
    .catch(function(err){
      setError(err.response.data.message)
    })
    .then((response) => {
      if(response && response.data.status === 'approved') {
        
        setVerified(true)            

        if(props.setPhone) {
          props.setPhone(
            {...props.phone,
                country: form.country,
                number: form.phone
            })
        }
        props.setOtpVerified(true)  

      } else {
        setError('Invalid SMS code. Please try again.')
      }
    })
    .finally(() => {
      setLoading(false)
    }) 
    
  }

  return (
    <div className="flex flex-col">
      <label className="font-bold">{t('your_phone')}</label>
      <div className="text-sm font-medium text-gray-500">
        <span dangerouslySetInnerHTML={{__html: t('phone_otp_notice') }}/>
      </div>
      <div className="flex flex-col gap-3 mt-1 mb-3">
        <div className="relative w-full">
          <span className="absolute top-[9px] left-3">+86</span>
          <input className="!pl-12 w-full" type="number" value={form.phone} onChange={(e) => setForm({...form,phone: e.target.value})} placeholder={t('your_phone')}/>
        </div>
        <button disabled={smsLock ? true : ""} onClick={() => checkPhone() } className={classNames(smsLock ? "bg-gray-500":"bg-[#8B8444]","w-full md:w-auto text-sm font-bold opacity-90 hover:opacity-100 p-3 px-4 rounded-lg")}>
          {
            !smsLock ?
            t('send_sms')
            :
            <Countdown date={Date.now() + smsCountdown} renderer={countdown}/>
          }
        </button>
      </div>      
      {
        smsSent !== false &&
        <>
          <label className="font-bold">{t('verify_sms_otp')}</label>
          <div className="flex mt-1 gap-3">                  
            <input type="number" value={form.code} onChange={(e) => setForm({...form,code: e.target.value})} placeholder={t('sms_code')} className="w-[120px]" />
            <button disabled={loading || verified ? true : ''} onClick={() => verifySMS() } 
              className={classNames(loading ? "bg-gray-500": (verified ? "" : "bg-[#8B8444] opacity-90 hover:opacity-100"),"text-sm font-bold p-3 px-4 rounded-lg")}>
              {
                loading ?
                <>
                  <Spinner />
                </>
                :
                <>
                  {
                    !verified ? t('verify_otp')                    
                    :
                    <div className="flex gap-1 text-green-500">
                      <CheckIcon className="w-5"/> {t('verify_success')}
                    </div>
                  }
                </>
              }
            </button>
          </div>
        </>
      }
      {
        error &&
        <div className="text-red-500 mb-5">{t(error)}</div>
      }
    </div>
  );
}